// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

.moreverticonmenuitem .MuiTypography-root {
  margin: 0;
}

.MuiPopover-root.templatesPage {
  margin-left: -110px;
}
.MuiPopover-root.viewpasscodeMorevertIcon {
  margin-left: -40px;
}

.moreverticonmenuitem.disabled.SendEmail,
.moreverticonmenuitem.disabled.Download {
  pointer-events: none;
  opacity: 0.5;
}
/* Adjust margin-left for .MuiPopover-root.viewpasscodeMorevertIcon based on viewport width */
@media (min-width: 1000px) and (max-width: 1100px) {
  .MuiPopover-root.viewpasscodeMorevertIcon {
    margin-left: -8px; /* Smallest screen size */
  }
}

@media (min-width: 1200px) and (max-width: 1400px) {
  .MuiPopover-root.viewpasscodeMorevertIcon {
    margin-left: -20px; /* Medium screen size */
  }
}

@media (min-width: 1500px) and (max-width: 1600px) {
  .MuiPopover-root.viewpasscodeMorevertIcon {
    margin-left: -30px; /* Largest screen size */
  }
}

.moreverticonmenuitem.MuiMenuItem-root {
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}

.moreverticonmenuitem.abandon-action .MuiTypography-root,
.moreverticonmenuitem.abandon-action img {
  color: var(--abandonColor);
  filter: none;
}

.moreverticonmenuitem.abandon-action {
  color: var(--abandonColor);
}

.airaList .moreverticonmenuitem .MuiTypography-root {
  font-family: var(--default-FontName);
  font-weight: var(--buttonFontWeight);
  font-size: var(--pcnHeaderFontSize);
  color: var(--airagridHeaderColor);
}
`, "",{"version":3,"sources":["webpack://./src/views/components/base/moreVertIcon/MoreVertIcon.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;EACpB,YAAY;AACd;AACA,6FAA6F;AAC7F;EACE;IACE,iBAAiB,EAAE,yBAAyB;EAC9C;AACF;;AAEA;EACE;IACE,kBAAkB,EAAE,uBAAuB;EAC7C;AACF;;AAEA;EACE;IACE,kBAAkB,EAAE,wBAAwB;EAC9C;AACF;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,mCAAmC;EACnC,iCAAiC;AACnC","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n\n.moreverticonmenuitem .MuiTypography-root {\n  margin: 0;\n}\n\n.MuiPopover-root.templatesPage {\n  margin-left: -110px;\n}\n.MuiPopover-root.viewpasscodeMorevertIcon {\n  margin-left: -40px;\n}\n\n.moreverticonmenuitem.disabled.SendEmail,\n.moreverticonmenuitem.disabled.Download {\n  pointer-events: none;\n  opacity: 0.5;\n}\n/* Adjust margin-left for .MuiPopover-root.viewpasscodeMorevertIcon based on viewport width */\n@media (min-width: 1000px) and (max-width: 1100px) {\n  .MuiPopover-root.viewpasscodeMorevertIcon {\n    margin-left: -8px; /* Smallest screen size */\n  }\n}\n\n@media (min-width: 1200px) and (max-width: 1400px) {\n  .MuiPopover-root.viewpasscodeMorevertIcon {\n    margin-left: -20px; /* Medium screen size */\n  }\n}\n\n@media (min-width: 1500px) and (max-width: 1600px) {\n  .MuiPopover-root.viewpasscodeMorevertIcon {\n    margin-left: -30px; /* Largest screen size */\n  }\n}\n\n.moreverticonmenuitem.MuiMenuItem-root {\n  padding-top: 3px !important;\n  padding-bottom: 3px !important;\n}\n\n.moreverticonmenuitem.abandon-action .MuiTypography-root,\n.moreverticonmenuitem.abandon-action img {\n  color: var(--abandonColor);\n  filter: none;\n}\n\n.moreverticonmenuitem.abandon-action {\n  color: var(--abandonColor);\n}\n\n.airaList .moreverticonmenuitem .MuiTypography-root {\n  font-family: var(--default-FontName);\n  font-weight: var(--buttonFontWeight);\n  font-size: var(--pcnHeaderFontSize);\n  color: var(--airagridHeaderColor);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
